/**
 * Generates GraphQL request body
 * @param query GraphQL query
 * @returns GraphQL request body
 */
export default function graphql(query: string, variables?: Record<string, any>) {
  return {
    query,
    variables,
  }
}
